import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { useAuth } from '@/contexts/AuthContext';
import { Analytics } from '@/services/analytics.service';

/**
 * Renderless component that tracks page views on route changes.
 * Waits for auth to settle so events have the correct distinct_id.
 * Deduplicates consecutive identical pathnames (StrictMode double-mount).
 */
export function PageViewTracker() {
  const location = useLocation();
  const { isLoading } = useAuth();
  const lastTrackedRef = useRef<string | null>(null);

  useEffect(() => {
    if (isLoading) return;
    if (lastTrackedRef.current === location.pathname) return;

    lastTrackedRef.current = location.pathname;
    Analytics.trackPageView(location.pathname);
  }, [location.pathname, isLoading]);

  return null;
}
